import { Flex } from '@chakra-ui/react'

export const Logo = () => {
  return (
    <Flex alignItems='center' justifyContent='center' mb='60px' pt={100}>
      <img alt='HiveWatch' height={71} src='/FullLogo-White.svg' width={311} />
    </Flex>
  )
}
